import React, { Component } from 'react';

import styles from './styles';

class Callback extends Component {
  render() {
    return (
      <div style={styles.container}>
        <img alt="Logo" src="/images/logo.png"/>
        <div>Processing...</div>
      </div>
    );
  }
}

export default Callback;



// WEBPACK FOOTER //
// ./src/components/Authentication/Callback/index.js